var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavyBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -20 -20 h 1460 v 22 h -1460 z",
    fill: "#00525E",
    shapeRendering: "crispEdges"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M -20 -45 h 1460 v 48 c -5 -0.2 -9.7 2.3 -14 2.4 h -4.2 l -0.3 -0.1 h -0.5 l -3.9 -0.1 h -0.2 l -59.4 2 h -1.9 l -10.6 0.4 c -2.7 0 -5.5 0.2 -8 0.3 h -0.2 c -2.7 0.2 -5.4 0.4 -8 0.4 l -18 0.4 h -0.3 c -23 0.5 -61.3 5.7 -103.5 5.7 c -12.2 0 -24.1 0 -35.4 -0.2 h -1.6 c -7 0 -27 -0.3 -33.8 -0.5 h -17.8 c -6.9 -0.3 -14 -0.6 -21 -0.6 h -18 c -29.3 0 -57.6 -4.7 -87.5 -5 h -0.3 l -3.8 -0.1 l -11.7 -0.1 c -16 0 -31 0.5 -47 1.1 h -0.7 a 2879.8 2879.8 0 0 1 -22.7 1 a 71 71 0 0 1 -8.5 0.2 l -44 -0.4 h -1.2 l -99.8 -0.7 l -9.8 -0.5 h -0.1 a 437.3 437.3 0 0 0 -32.1 -0.6 c -5 0.3 -18.2 0.6 -55.2 0.6 c -47.5 0 -85.8 4 -99.2 2.9 a 873 873 0 0 0 -54 -2 h -1.4 a 968.7 968.7 0 0 0 -49.4 -0.4 h -18 c -4.3 0 -9.2 -0.2 -15.4 -0.4 h -2.1 a 1300.2 1300.2 0 0 0 -51 -1 c -15.7 0 -42.2 -4 -61.3 -3.7 c -6.4 0.3 -70.4 4.8 -79.4 4.8 h -14.2 l -14 -0.1 h -3.5 c -24.5 0.1 -84.4 2.5 -151 4 l -7.1 0.8 l -40.2 -3 c -4.3 -0.9 -8.7 -0.8 -13.3 -0.9 v -54.6 z",
    fill: "#00525E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyBottom);
export default __webpack_public_path__ + "static/media/wavy_bottom.6be5db1601d0418671a25db8d5978846.svg";
export { ForwardRef as ReactComponent };